import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import bannersAPI from '../../sources/api/bannersAPI';

// constants
import { GET_BANNERS } from '../../constants/bannersTypes';

// lib
import httpSaga from '../../lib/httpSaga';

export function* getBanners(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;
  try {
    yield *httpSaga(GET_BANNERS, call(bannersAPI.all));
  } catch (e) {
    yield put(error(GET_BANNERS, e));
  } finally {
    yield put(doneIndicator(GET_BANNERS));
  }
}

export function* watchGetBanners() {
  yield takeEvery(GET_BANNERS, getBanners);
}

export default function* root() {
  yield all([
    fork(watchGetBanners)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/banners/getBanners.js